import React, { FC } from "react";
import styles from "./PrintSectionHeader.module.css";

const PrintSectionHeader: FC = ({ children }) => {
  return <div className={styles.sectionHeader}>{children}</div>;
};

export default PrintSectionHeader;
